import IconClose from './IconClose'

export const Icon = {
  component: IconClose,
  props: {},
  group: 'icons',
}

export const IconSmall = {
  component: IconClose,
  props: {
    size: 'small',
  },
  group: 'icons',
}
